import { createReducer } from '../../lib/Utils'
import {
  INIT_PUSHER_FULFILLED,
  BIND_TO_CHANNEL_EVENT_FULFILLED,
  UNBIND_FROM_CHANNEL_EVENT_FULFILLED,
} from './actions'

const initialState = {
  isInitialized: false,
  eventStates: {},
}

export default createReducer(initialState, {
  [INIT_PUSHER_FULFILLED]: (state) => {
    const newState = { ...state, isInitialized: true }
    return newState
  },
  [BIND_TO_CHANNEL_EVENT_FULFILLED]: (state, action) => {
    const newState = {
      ...state,
      eventStates: { ...state.eventStates, ...action.payload.eventStates },
    }
    return newState
  },
  [UNBIND_FROM_CHANNEL_EVENT_FULFILLED]: (state, action) => {
    const newState = {
      ...state,
      eventStates: { ...state.eventStates, ...action.payload.eventStates },
    }
    return newState
  },
})
